import httpStore from "@/api/httpStore.js";

export function getPayments(filters) {
  const newFilters = Object.entries(filters)
    .map(([key, val]) => {
      return `${encodeURIComponent(key)}=${encodeURIComponent(val)}`;
    })
    .join("&");
  return httpStore.get(`/payments/set?${newFilters}`).then(res => {
    return res.data;
  });
}

export function getPaymentsStats(filters) {
  return httpStore
    .get(`/payments/stats`, { params: filters })
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}

export function getPaymentTypes(department = "ALL") {
  return httpStore
    .get(`/payments/types`, { params: { department } })
    .then(res => {
      return res.data;
    });
}

export function getPosPayments(filters) {
  return httpStore.get(`/pos/set`, { params: filters }).then(res => {
    return res.data;
  });
}

export function getPosPayment(paymentId) {
  return httpStore
    .get(`/pos/single/${paymentId}`)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}

export function getPayment(paymentId) {
  return httpStore
    .get(`/payments/single/${paymentId}`)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}

export function getOrderPaymentApi(paymentId) {
  return httpStore
    .get(`/orders/payment/${paymentId}`)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}

export function processPosPayment(paymentData) {
  return httpStore
    .post(`/pos/payment`, paymentData)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}

export function markInfoautoProcessed(paymentId) {
  return httpStore
    .put(`/pos/infoauto_processed/${paymentId}`)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}

// Recibo de un pago web (orders_v2_payments), refunds incluidos
export function sendOrderPaymentReceipt(paymentId, email) {
  return httpStore
    .post(`/payments/send_receipt`, { paymentId, email })
    .then(res => res.data);
}

export function sendPosReceipt(paymentId, email) {
  return httpStore
    .post(`/pos/send_receipt`, { paymentId, email })
    .then(res => {
      return res.data;
    })
    .catch(e => {
      throw e;
    });
}
